import { canonicalJson } from "@gigsync/protocol";
import { Collection } from "../ports.js";
/** What the owner chose for records that differ on the two phones. */
export const MergeChoice = { keepMine: "keep_mine", takeTheirs: "take_theirs" };
/**
 * A job this phone only refilled from the owner's record on GigSync: the old phone's full copy (with its words and
 * messages) simply replaces it, since the refill was only ever a stand-in for it.
 */
const standIn = (collection, mine) => collection === Collection.jobs && typeof mine === "object" && mine !== null && "restored" in mine;
/** Compares the old phone's records with this phone's, record by record, by collection and id. */
export async function planMerge(storage, records) {
    const incoming = Object.entries(records).flatMap(([collection, list]) => list.map((r) => ({ collection, id: r.id, value: r.value })));
    const existing = await Promise.all(incoming.map((r) => storage.get(r.collection, r.id)));
    const plan = { add: [], conflicts: [], same: 0 };
    incoming.forEach((record, i) => {
        const mine = existing[i];
        if (mine === undefined || standIn(record.collection, mine))
            plan.add.push(record);
        else if (canonicalJson(mine) === canonicalJson(record.value))
            plan.same += 1;
        else
            plan.conflicts.push(record);
    });
    return plan;
}
/** Writes the plan: every new record, and the conflicting ones only when the owner chose the old phone's. */
export async function applyMerge(storage, plan, choice) {
    const writes = choice === MergeChoice.takeTheirs ? [...plan.add, ...plan.conflicts] : plan.add;
    await Promise.all(writes.map((r) => storage.put(r.collection, r.id, r.value)));
    return writes.length;
}
//# sourceMappingURL=merge.js.map